/**
 * Cart out-of-stock UI + checkout guard.
 * Reads inventory from each line row (rendered by Liquid, refreshed on cart morph).
 * No /cart.js or /products/*.js requests.
 */
(function () {
  'use strict';

  let config = window.CartInventoryValidation || {};
  let MSG = config.lineMessage || 'Out of stock';
  let deferredId;

  function getLineQuantity(row) {
    let input = row.querySelector('input[data-cart-line]');
    if (input instanceof HTMLInputElement) {
      let fromInput = parseInt(input.value, 10);
      if (Number.isFinite(fromInput)) return fromInput;
    }
    let fromRow = parseInt(row.dataset.lineQuantity, 10);
    return Number.isFinite(fromRow) ? fromRow : 0;
  }

  /** Same rules as cart-products.liquid cart_line_oos. */
  function isRowInvalid(row) {
    let qty = getLineQuantity(row);
    if (qty <= 0) return false;

    if (row.dataset.variantAvailable === 'false') return true;

    if (
      row.dataset.inventoryManagement === 'shopify' &&
      row.dataset.inventoryPolicy === 'deny'
    ) {
      let inventory = parseInt(row.dataset.inventoryQuantity, 10);
      if (Number.isFinite(inventory) && qty > inventory) return true;
    }

    return false;
  }

  /** Reset validation UI when the cart has no line items (empty cart). */
  function clearEmptyCartState() {
    document.querySelectorAll('[data-cart-inventory-alert]').forEach(function (el) {
      el.hidden = true;
    });

    document.querySelectorAll('.cart-items__table-row--out-of-stock').forEach(function (row) {
      row.classList.remove('cart-items__table-row--out-of-stock');
    });

    document.querySelectorAll('[data-cart-stock-message]').forEach(function (msg) {
      msg.hidden = true;
    });

    /* Checkout disabled state for empty cart is handled in Liquid; do not touch buttons here. */
  }

  function updateCheckoutButtons(hasInvalid) {
    document
      .querySelectorAll('cart-items-component button.cart__checkout-button[name="checkout"]')
      .forEach(function (btn) {
        if (btn instanceof HTMLButtonElement) {
          btn.disabled = hasInvalid;
        }
      });
  }

  function validateFromDom() {
    let rows = document.querySelectorAll('.cart-items__table-row[data-key]');

    if (!rows.length) {
      clearEmptyCartState();
      return;
    }

    let hasInvalid = false;

    rows.forEach(function (row) {
      if (!(row instanceof HTMLElement)) return;

      let invalid = isRowInvalid(row);
      if (invalid) hasInvalid = true;

      row.classList.toggle('cart-items__table-row--out-of-stock', invalid);

      let msg = row.querySelector('[data-cart-stock-message]');
      if (msg) {
        msg.hidden = !invalid;
        if (invalid) msg.textContent = MSG;
      }
    });

    document.querySelectorAll('[data-cart-inventory-alert]').forEach(function (el) {
      el.hidden = !hasInvalid;
    });

    updateCheckoutButtons(hasInvalid);
  }

  /** Run after cart morph (cart:update fires before morphSection completes). */
  function deferValidate() {
    clearTimeout(deferredId);
    deferredId = setTimeout(validateFromDom, 0);
  }

  /** Instant feedback when the shopper changes quantity (uses input value). */
  function validateNow() {
    clearTimeout(deferredId);
    validateFromDom();
  }

  function cartHasLineItems() {
    return document.querySelector('.cart-items__table-row[data-key]') !== null;
  }

  function observeCartItems() {
    if (!cartHasLineItems()) return;

    document.querySelectorAll('cart-items-component').forEach(function (root) {
      if (root.__cartInventoryObserved) return;
      if (!root.querySelector('.cart-form, .cart-items__table-row[data-key]')) return;

      root.__cartInventoryObserved = true;

      new MutationObserver(deferValidate).observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'data-inventory-quantity',
          'data-inventory-management',
          'data-inventory-policy',
          'data-variant-available',
          'data-line-quantity',
        ],
      });
    });
  }

  function boot() {
    deferValidate();
    observeCartItems();
  }

  document.addEventListener('cart:update', function () {
    deferValidate();
    observeCartItems();
  });

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('pageshow', deferValidate);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') deferValidate();
  });

  let drawer = document.getElementById('CartDrawer');
  if (drawer) {
    new MutationObserver(function () {
      if (drawer.hasAttribute('open')) deferValidate();
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  document.addEventListener(
    'change',
    function (e) {
      if (e.target instanceof HTMLInputElement && e.target.matches('input[data-cart-line]')) {
        validateNow();
      }
    },
    true
  );

  if (document.readyState !== 'loading') {
    boot();
  }
})();
